/**
 * Converts Contentful's "CTACard" content type to the appropriate component
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import CTACard from 'components/CTACard'
import { convertRichTextToComponent } from '../utils'

const ContentfulCtaCard = ({
  className, backgroundColor, title, subtitle, linkText, href, flipped, icon, content,
}) => {
  const ctaCardProps = {
    className,
    backgroundColor,
    title: convertRichTextToComponent(title),
    subtitle: convertRichTextToComponent(subtitle),
    linkText,
    href,
    flipped,
    icon: {
      src: icon?.src?.file?.url,
      alt: icon?.alt,
    },
  }

  return (
    <CTACard {...ctaCardProps}>
      {content ? convertRichTextToComponent(content, true) : null}
    </CTACard>
  )
}

ContentfulCtaCard.propTypes = {
  className: PropTypes.string,
  backgroundColor: PropTypes.string,
  icon: PropTypes.object,
  title: PropTypes.object,
  subtitle: PropTypes.object,
  linkText: PropTypes.string,
  href: PropTypes.string,
  flipped: PropTypes.bool,
  content: PropTypes.object,
}

export default ContentfulCtaCard
